import { useEffect, useState } from "react";
import clsx from "clsx";
import { parseTagIcon } from "../utils/tagIcons";

interface TagIconProps {
  icon: string;
  size?: number;
  className?: string;
  title?: string;
  /** Applies white tint to SVG icon, useful on colored marker backgrounds. */
  whiteTint?: boolean;
}

export function TagIcon({
  icon,
  size = 16,
  className,
  title,
  whiteTint = false,
}: TagIconProps) {
  const [failed, setFailed] = useState(false);
  const parsed = parseTagIcon(icon);
  useEffect(() => {
    setFailed(false);
  }, [icon]);

  if (failed) {
    return (
      <span
        className={clsx("material-symbols-outlined leading-none", className)}
        style={{ fontSize: size, color: whiteTint ? "white" : undefined }}
      >
        location_on
      </span>
    );
  }

  if (parsed.kind === "custom") {
    return (
      <img
        src={parsed.dataUrl}
        alt=""
        title={title}
        className={clsx("object-contain", className)}
        style={{ width: size, height: size }}
        onError={() => setFailed(true)}
      />
    );
  }

  const src = `https://unpkg.com/@phosphor-icons/core@2.1.1/assets/duotone/${parsed.name}-duotone.svg`;

  return (
    <img
      src={src}
      alt=""
      title={title ?? parsed.name}
      className={clsx("object-contain", className)}
      style={{
        width: size,
        height: size,
        filter: whiteTint
          ? "brightness(0) saturate(100%) invert(1)"
          : undefined,
      }}
      onError={() => setFailed(true)}
    />
  );
}
